<template>
  <select
    v-model="selectedItem"
    data-automation="change-bioc-version-select"
  >
    <option
      v-for="biocVersion in biocVersions"
      :key="biocVersion.bioc_version"
      :value="biocVersion.bioc_version"
    >
      {{ biocVersionDisplay(biocVersion) }}
    </option>
  </select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'BiocVersionPicker',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      selectedItem: this.value,
    }
  },
  computed: {
    ...mapState({
      biocVersions: state => state.status.biocVersions,
    }),
  },
  watch: {
    selectedItem: function (newValue, oldValue) {
      this.$emit('change', newValue)
    },
  },
  methods: {
    biocVersionDisplay: function (biocVersion) {
      const rVersion = biocVersion.r_version ? ` (R ${biocVersion.r_version})` : ''
      return `Bioconductor ${biocVersion.bioc_version}` + rVersion
    },
  },
}

</script>
